export default __webpack_public_path__ + "static/media/ellipses-icon.5f2b0960.svg";